import { render } from "./VoipRiepilogue.vue?vue&type=template&id=29c98092"
import script from "./VoipRiepilogue.vue?vue&type=script&lang=js"
export * from "./VoipRiepilogue.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "29c98092"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29c98092', script)) {
    api.reload('29c98092', script)
  }
  
  module.hot.accept("./VoipRiepilogue.vue?vue&type=template&id=29c98092", () => {
    api.rerender('29c98092', render)
  })

}

script.__file = "src/views/services/modules/voip/pills/VoipRiepilogue.vue"

export default script